export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validatePhone(phone: string): boolean {
  return /^[+\d\s\-()]{7,15}$/.test(phone);
}

export function validateMinLen(value: string, min: number): boolean {
  return value.length >= min;
}
